"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownButton = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const button_1 = __importDefault(require("@kyruus/button"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.DropdownButton = (0, styled_1.default)(button_1.default) `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  &:hover {
    background-color: ${(0, ui_theme_1.fromTheme)('color_item_hover')};
  }
`;
//# sourceMappingURL=Dropdown.styles.js.map